export var sortItemsIntoColumns = function sortItemsIntoColumns(items, numberOfItemsPerColumn) {
  if (!items.length) {
    return [];
  }

  var currentIndex = 0;
  return items.reduce(function (accumulator, item, index) {
    if (index !== 0 && index % numberOfItemsPerColumn === 0) {
      accumulator[++currentIndex] = [];
    }

    accumulator[currentIndex].push(item);
    return accumulator;
  }, [[]]);
};